import { strings } from "../constants/stringConstants";
import { formatter, reFormatPrice } from "./common";

export const validate = (validator, fields) => {
  if (validator) {
    let errors = {};
    const unfilled = validator.required.filter((field) => !fields[field]);
    if (validator.custom) {
      const result = validator.custom.map(
        ({ error, validate, fields: validationFields }, params) => {
          const valid = validate(
            ...validationFields.map((field) => fields[field]),
            params
          );

          const errors = {};

          validationFields.forEach((item) => {
            errors[item] = error;
          });
          return valid ? null : errors;
        }
      );
      const customErrors = result.filter(Boolean);
      if (customErrors.length) {
        customErrors.forEach((error) => {
          errors = Object.assign(errors, error);
        });
      }
    }
    if (unfilled.length) {
      unfilled.forEach((field) => {
        errors[field] = "Field can not be empty";
      });
    }
    return { errors };
  }
  return { errors: null };
};

export const email = (fields) => ({
  error: "Incorrect email format",
  validate: validateEmail,
  fields,
});

export const maxVal = (fields, maxPrice = 999999) => ({
  error: `Max value should be ${formatter(maxPrice)} or less`,
  validate: (price) => reFormatPrice(price) <= maxPrice,
  fields,
});

export const samePasswords = (fields) => ({
  error: "Passwords must be same",
  validate: (password, repeat) => password === repeat,
  fields,
});

export const checkDates = (fields) => ({
  error: "The date of finish cannot be less than date of start.",
  validate: (startDate, endDate) => new Date(startDate) < new Date(endDate),
  fields,
});

export const password = (fields) => ({
  error: "Passwords must contain at least 8 characters",
  validate: validatePassword,

  fields,
});

export const PasswordWithoutSpaces = (fields) => ({
  error: "Passwords should not contain spaces",
  validate: validatePasswordWithoutSpaces,
  fields,
});

export const StrongPassword = (fields) => ({
  error: strings.WEAK_PASSWORD_ERROR,
  validate: validateStrongPassword,
  fields,
});

export const phone = (fields) => ({
  error: "Incorrect phone format",
  validate: validateMobile,
  fields,
});

export const priceNotZero = (fields) => ({
  error: "Price must be greater than zero",
  validate: (price) => Number(price.toString().replace(/\D+/g, "")) > 0,
  fields,
});

export const validatePassword = (password) => {
  const re = /^.*.{8,20}$/;

  return re.test(password);
};

export const validatePasswordWithoutSpaces = (password) => {
  const re = /^[\S]+$/;

  // const re = /^(?!.*\s).*.{8,20}$/;

  return re.test(password);
};

export const validateEmail = (email) => {
  /* eslint-disable no-useless-escape */
  const re =
    /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(email);
};

export const validateStrongPassword = (password) => {
  // const re =
  //   /((?=.*\d)|(?=.*\W+))(?![.\n])(?=.*[!@#$&*])(?=.*[A-Z])(?=.*[a-z]).*$/;
  const re =
    /((?=.*\d)|(?=.*\W+))(?![.\n])(?=.*[!"#$%&'()*+,-./:;<=>?@[\]^_`{|}~])(?=.*[A-Z])(?=.*[a-z]).*$/;

  return re.test(password);
};

export const validatePhone = (phone) => {
  /* eslint-disable no-useless-escape */
  // const re = /^\(\d{3}\) \d{3}-\d{4}$/;
  const re = /^([+]\d{2})?\d{10}$/;
  return re.test(phone);
};

export const validateMobile = (mobile) => {
  /* eslint-disable no-useless-escape */
  // const re = /^([+]\d{2})?\d{10}$/;

  // starts from 6,7,8,9 and has digits only for next 9 places/.
  const re = /^[6789]\d{9}$/;
  return re.test(mobile);
};
